require.config(
{
    waitSeconds: 200,
    urlArgs:'v=' + (((typeof window==='object') && (window.cnf.debug===true)) ? Date.now() : '0.0.1'),
    paths: {
        jquery      : 'vendor/jquery-passthrough',
        jqueryBridget:'vendor/jquery-bridget-master/jquery-bridget',
        jqueryMobile:'vendor/jquery.mobile/jquery.mobile.custom',
        jqueryMousewheel:'vendor/jquery.mousewheel/jquery.mousewheel.min',
        fancybox    : 'vendor/fancybox/source/jquery.fancybox',
        TweenMax    : 'vendor/greensock/src/minified/TweenMax.min',
        TweenLite   : 'vendor/greensock/src/minified/TweenLite.min',
        TimelineMax : 'vendor/greensock/src/minified/TimelineMax.min',
        CSSPlugin   : 'vendor/greensock/src/minified/plugins/CSSPlugin.min',
        easing      : 'vendor/greensock/src/minified/easing/EasePack.min',
        scrollTo:'vendor/greensock/src/minified/plugins/ScrollToPlugin.min',
        underscore:'vendor/underscore-master/underscore',
        flickity:'vendor/flickity-master/dist/flickity.pkgd.min',
        _pubsub:'pubsub/_pubsub',
        isotope:'vendor/isotope.pkgd.min',
        picturefill:'vendor/picturefill.min',
        /**
         * @jira FDZ-712, @date 2023-10-19: disabled since plugin v6
        instagram_feed : '../../../../../plugins/instagram-feed-pro/js/sbi-scripts',
        */
        vimeo:'vendor/vimeo/player',
        isotope:'vendor/metafizzy/isotope.pkgd.min',
        IntersectionObserverPolyfill : 'vendor/intersection-observer-polyfill/intersection-observer',
        Draggable: 'vendor/greensock/src/minified/utils/Draggable.min'
    },
    shim: {
        application:{
            deps:['picturefill']
        },
        jqueryCycle: {
            deps:['jquery', 'jqueryMousewheel','jqueryMobile', 'TweenMax']
        },
        jqueryScroll:{
            deps:['jquery']
        },
        fancybox: {
            deps: ['jquery']
        },
        TweenMax: {
            deps: ['CSSPlugin', 'easing', 'Draggable']
        },
        TimelineMax: {
            deps: ['easing']
        }
    }
});

/**
 * THIS IS THE MAIN ENTRY POINT
 */
require(['application'], function(app)
{
    'use strict';

    new app(
    {
        debug : window.cnf.debug
    });
});

define("main", function(){});

